import React from "react";
import classNames from "classnames";

interface VisibleProps {
  children: React.ReactNode;
  xl?: boolean;
  lg?: boolean;
  md?: boolean;
  sm?: boolean;
  xs?: boolean;
}

export function Visible(props: VisibleProps) {
  const { children, xl, lg, md, sm, xs } = props;

  return (
    <div
      className={classNames({
        "visible-xs": xs,
        "visible-sm": sm,
        "visible-md": md,
        "visible-lg": lg,
        "visible-xl": xl,
      })}
    >
      {children}
    </div>
  );
}
